import { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Preloader from '@/sections/Preloader';
import Navbar from '@/components/Navbar';
import Hero from '@/sections/Hero';
import About from '@/sections/About';
import MemeGenerator from '@/sections/MemeGenerator';
import MemeGallery from '@/sections/MemeGallery';
import Footer from '@/sections/Footer';

export default function App() {
  const [loaded, setLoaded] = useState(false);

  const handleComplete = useCallback(() => {
    setLoaded(true);
  }, []);

  return (
    <>
      <Preloader onComplete={handleComplete} />
      <AnimatePresence>
        {loaded && (
          <motion.div
            key="main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="relative min-h-screen"
            style={{ background: '#080808' }}
          >
            <div
              className="pointer-events-none fixed -top-40 -left-24 h-[38rem] w-[38rem] rounded-full"
              style={{ background: 'radial-gradient(circle, rgba(212,175,55,0.12) 0%, rgba(212,175,55,0.03) 34%, transparent 68%)', filter: 'blur(10px)' }}
            />
            <div
              className="pointer-events-none fixed -bottom-48 -right-24 h-[42rem] w-[42rem] rounded-full"
              style={{ background: 'radial-gradient(circle, rgba(255,160,0,0.08) 0%, rgba(255,160,0,0.02) 36%, transparent 72%)', filter: 'blur(14px)' }}
            />
            <div className="noise-overlay" />
            <Navbar />
            <main>
              <Hero />
              <About />
              <MemeGenerator />
              <MemeGallery />
            </main>
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
